<div class="content-shadow" [hidden]="(dataSource.total$ | async) === 0">
  <stf-table-toolbar>
    <section table-has-no-selected>
      <section class="mat-table-toolbar mat-default">
        <div class="mat-toolbar-tools">
          <span class="mat-toolbar-tools__title_sm">Міжнародні відправлення</span>
        </div>
      </section>
    </section>
  </stf-table-toolbar>

  <mat-progress-bar [style.opacity]="(dataSource.loading$ | async) ? 1 : 0"
                    mode="indeterminate">
  </mat-progress-bar>

  <div class="table-wrapper">
    <table class="table" mat-table #table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <ng-container matColumnDef="docNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [start]="'desc'" app-sort-header>Номер</th>
        <td mat-cell *matCellDef="let invoice">
          <div class="doc-number-container">
            <span class="nowrap doc-number copy-content">
              {{ invoice.Number | fineDocNumber }}
              <button mat-icon-button class="copy-content__btn"
                      [appCopy]="invoice?.Number"
                      [matTooltip]="'Скопіювати'" matTooltipPosition="below">
              <mat-icon class="material-icons_grey copy-content__icon">content_copy</mat-icon>
            </button>
            </span>
            <i class="material-icons material-icons_table material-icons_red material-icons-hover_red"
               [matTooltip]="'Міжнародна доставка'" matTooltipPosition="below">language
            </i>
            <mat-icon *ngIf="invoice.register"
                      class="material-icons material-icons_grey material-icons_table register_icon"
                      [matTooltip]="'Документ в реєстрі: ' + (invoice.register.description || invoice.register.docNumber)"
                      matTooltipPosition="below">
            </mat-icon>
            <i *ngIf="invoice.isPrinted === true"
               class="material-icons material-icons_grey material-icons_table outline_none"
               [matTooltip]="'Посилку роздруковано'"
               matTooltipPosition="below">print
            </i>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Дата створення</th>
        <td mat-cell *matCellDef="let invoice">{{ invoice?.CreationDate | dateTransform }}</td>
      </ng-container>

      <ng-container matColumnDef="CountryRecipientDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Країна отримувача</th>
        <td mat-cell *matCellDef="let invoice">{{ invoice?.CountryRecipientDescription || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Оголошена цінність</th>
        <td mat-cell
            *matCellDef="let invoice">{{ formatCostForInternationalInvoice(invoice.Cost || 0, invoice.CurrencyCode) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Вартість доставки</th>
        <td mat-cell
            *matCellDef="let invoice">{{ formatCostForInternationalInvoice(invoice.DocumentCost || 0, invoice.DocumentCostCurrencyCode) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Кількість місць</th>
        <td mat-cell *matCellDef="let invoice">{{ (invoice.PlacesAmount || 0) }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Опис відправлення</th>
        <td mat-cell *matCellDef="let invoice">
          <span>{{ invoice.CargoDescription || '&mdash;' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="receiver">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Отримувач</th>
        <td mat-cell *matCellDef="let invoice">
          {{ getRecipient(invoice) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="receiverPhone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Телефон отримувача</th>
        <td mat-cell *matCellDef="let invoice">
          <span class="nowrap copy-content">
            {{ '+' + invoice?.PhoneRecipient }}
            <button mat-icon-button class="copy-content__btn"
                    [appPhoneCopy]="invoice?.PhoneRecipient"
                    [matTooltip]="'Скопіювати'" matTooltipPosition="below">
              <mat-icon class="material-icons_grey copy-content__icon">content_copy</mat-icon>
            </button>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="receiverCity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Місто отримувача</th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.CityRecipient }}</td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Адреса отримання</th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.AddressRecipient }}</td>
      </ng-container>

      <ng-container matColumnDef="delivery">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Тип доставки</th>
        <td mat-cell *matCellDef="let invoice">{{ invoice?.DeliveryTypeDescription }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Статус заявки</th>
        <td mat-cell *matCellDef="let invoice">{{ getStatus(invoice?.State) || '&mdash;'  }}</td>
      </ng-container>

      <ng-container matColumnDef="statusComment">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header class="nowrap">Коментар до статусу</th>
        <td mat-cell *matCellDef="let invoice">{{ getStatusComment(invoice?.State, invoice?.SubStateDocument) || '&mdash;'  }}</td>
      </ng-container>

      <ng-container matColumnDef="OrderNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header class="nowrap">Внутрішній номер</th>
        <td mat-cell *matCellDef="let invoice">{{ invoice?.OrderNumber || '&mdash;' }}</td>
      </ng-container>

      <ng-container matColumnDef="editDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header app-sort-header>Дата та час останнього редагування</th>
        <td mat-cell *matCellDef="let invoice">{{ invoice?.DateTime |  dateTransform: 'DD.MM.YYYY HH:mm:ss' }}</td>
      </ng-container>

      <ng-container matColumnDef="options" stickyEnd>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell class="mat-icon-cell" *matCellDef="let invoice">
          <button mat-icon-button
                  [matMenuTriggerFor]="appMenu"
                  (click)="$event.stopPropagation()">
            <i class="material-icons">more_vert</i>
          </button>
          <mat-menu #appMenu="matMenu" class="mat-menu_width_3">
            <button *ngIf="invoice.CanPrint"
                    mat-menu-item [matMenuTriggerFor]="printMenu">
              <mat-icon>print</mat-icon>
              Друкувати
            </button>

            <button mat-menu-item
                    [disabled]="!!invoice.registerDocNumber && !!invoice.register"
                    [confirmMsg]="'Ви справді хочете видалити цю посилку з реєстру?'"
                    [confirmBtnText]="'Видалити'"
                    [cancelBtnText]="'Скасувати'"
                    (confirm)="remove(invoice)">
              <mat-icon>delete</mat-icon>
              Видалити з реєстру
            </button>
          </mat-menu>

          <mat-menu #printMenu="matMenu" class="mat-menu_width_3">
            <button mat-menu-item (click)="print([invoice], PRINT_FORMS.INTERNATIONAL_MARKING)">
              Міжнародні документи, 2 копiї
            </button>
            <div [matTooltip]="!isZebraPrintAvailable(invoice?.State) ? 'Друк маркування доступний лише для відправлень зі статусом «Верифіковано»' : null"
                 matTooltipPosition="before">
              <button [disabled]="!isZebraPrintAvailable(invoice?.State)" mat-menu-item
                (click)="print([invoice], PRINT_FORMS.MARKING_5)">
                Маркування 100*100 типу “зебра”, PDF
              </button>
            </div>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let invoice; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [length]="dataSource.total$ | async" [pageSize]="itemsPerPage" (page)="onPageChange($event)"
                 [showFirstLastButtons]="false" [pageSizeOptions]="limitsList"></mat-paginator>
</div>

<mat-spinner [diameter]="56" class="mat-spinner-el"
             *ngIf="dataSource.loading$ | async"></mat-spinner>

<div class="d-flex flex-direction-column h-100"
     *ngIf="(dataSource.loading$ | async) === false && (dataSource.total$ | async) === 0">
  <div class="p-6">
    <p class="register-content__text register-content__text_lg">В реєстрі немає жодної посилки</p>
    <p class="register-content__text">Для швидкого додавання посилок, виділіть їх галочками та виконайте дію «Додати до
      реєстру»</p>
  </div>
</div>
